module.exports = __webpack_public_path__ + "static/media/settings.886c1c9a.svg";